module.exports = __webpack_public_path__ + "2901b0f85136338ee39c264a1f4feef6.svg";